const homepage_silder = (() => {
    let slider = new Swiper(".homepage-hero-swiper", {
      direction: "horizontal",
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      speed: 1400,
      effect: 'fade',
      autoplay: {
        delay: 5000
      },
      pagination: {                       
        el: '.swiper-pagination',
        renderBullet: function (index, className) {                 
            return `<span class="${className}">${index + 1}</span>` 
        },
        clickable: true
    },
    });
})();